import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, EventEmitter, OnInit, Output, ViewChild } from "@angular/core";
import { UtilsService } from "../../../../../auth/service/utils.service";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { CdkDragDrop, moveItemInArray, transferArrayItem } from "@angular/cdk/drag-drop";
import Italian from "flatpickr/dist/l10n/it";
import { FlatpickrOptions } from "ng2-flatpickr";
import { FormBuilder, FormControl, FormGroup, Validators } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { RequestService } from "../../request.service";
import moment from "moment";
import { BargainingService } from "../../../bargaining/bargaining.service";
import { AuthenticationService } from "../../../../../auth/service";
import { ToastrService } from "ngx-toastr";
import { IContentHeader } from "app/layout/components/content-header/content-header.component";

@Component({
  selector: "app-request-detail",
  templateUrl: "./request-detail.component.html",
  styleUrls: ["./request-detail.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RequestDetailComponent implements OnInit {
  @Output() callbackFn: EventEmitter<any> = new EventEmitter();
  @ViewChild("noteModal") noteModal: ElementRef;
  @ViewChild("noteDateModal") noteDateModal: ElementRef;
  public contentHeader: IContentHeader;
  public config: any;
  public tableLimit: number = 20;
  public basicDateOptions: FlatpickrOptions;
  public formGroup: FormGroup;
  public filter_string: string = "";
  public idRequest: string = "";
  public currentRequest: any = {};
  public showTab: any = "candidate";
  public dragEvent: any;
  public selectedUser: any;
  public selectedSuitableCandidate: any;
  public allStepList: any = [];
  public allTimeLineCandidates: any = [];
  public singleTimeLineCandidate: any = [];
  public suitablesCandidates: any = null;
  public suitablesEmployees: any = null;
  public suitablesExEmployees: any = null;
  public activeTab: string;
  public usedParameters: any = [];
  public landingStep: any;
  public step0 = [];
  public step1 = [];
  public step2 = [];
  public step3 = [];
  public step4 = [];
  public step5 = [];
  public step6 = [];
  public points = ["certifications", "city", "education_title", "figure", "languages", "rate", "site", "required_skills", "optional_skills"];
  public tabs_loaded_data: string[] = [];
  public parameterMax: number = 0;
  public close_motivation: string = null;
  public windowWidth: number = 0;
  public showSpinnerCandidate: boolean = true;
  public showSpinnerEmployee: boolean = true;
  public showSpinnerExEmployee: boolean = true;
  public openParameter: boolean = false;
  public editStepNumber: string = null;
  public me = null;

  constructor(
    public _utilService: UtilsService,
    public _modalService: NgbModal,
    private _formBuilder: FormBuilder,
    private route: ActivatedRoute,
    public router: Router,
    public requestService: RequestService,
    private bargainingService: BargainingService,
    public _authenticationService: AuthenticationService,
    private _changeDetectorRef: ChangeDetectorRef,
    public toastr: ToastrService,
  ) {
    this._utilService.disableAutoHideLoading();
    this.idRequest = this.route.snapshot.paramMap.get("id");
    this.config = {
      selectLimitItems: true,
      headerHeight: 30,
      rowHeight: window.innerWidth > 1440 ? 60 : 90,
      footerHeight: 40,
      scrollbarH: true,
    };
    this.windowWidth = window.innerWidth;
    this.me = this._authenticationService.currentUserSubject.value;
  }

  async ngOnInit() {
    if (!this._authenticationService.hasCapability("view_detail_customer_request")) {
      this._utilService.hideLoading();
      this.router.navigateByUrl("/dashboard/main");
      return false;
    }
    if (this.idRequest) {
      this.currentRequest = await this.requestService.getRequest(Number(this.idRequest));
      if (this.currentRequest.skills) {
        this.currentRequest.required_skills = this.currentRequest.skills.filter((skill) => skill.requested === 1);
        this.currentRequest.optional_skills = this.currentRequest.skills.filter((skill) => skill.requested === 0);
      } else {
        this.currentRequest.required_skills = [];
        this.currentRequest.optional_skills = [];
      }
    }
    if (this.currentRequest) {
      // Riempiamo il campo parametri usati controllando quali campi della richiesta sono stati usati
      if (this.currentRequest.certifications && this.currentRequest.certifications.length > 0) {
        this.usedParameters.push("certifications");
      }
      if (this.currentRequest.languages_complete && this.currentRequest.languages_complete.length > 0) {
        this.usedParameters.push("languages");
      }
      if (this.currentRequest.city && this.currentRequest.city.length > 0) {
        this.usedParameters.push("city");
      }
      if (this.currentRequest.education_title && this.currentRequest.education_title > 0) {
        this.usedParameters.push("education_title");
      }
      if (this.currentRequest.figure && this.currentRequest.figure.length > 0) {
        this.usedParameters.push("figure");
      }
      if (this.currentRequest.rate && this.currentRequest.rate > 0) {
        this.usedParameters.push("rate");
      }
      if (this.currentRequest.site && this.currentRequest.site.length > 0) {
        this.usedParameters.push("site");
      }
      if (this.currentRequest.required_skills && this.currentRequest.required_skills.length > 0) {
        this.usedParameters.push("required_skills");
      }
      if (this.currentRequest.optional_skills && this.currentRequest.optional_skills.length > 0) {
        this.usedParameters.push("optional_skills");
      }
    }
    this.parameterMax = 100 / this.usedParameters.length; /*Variabile per gestire il massimo che un parametro può avere*/

    this.route.queryParams.subscribe((params) => {
      this.showTab = params.destination ? params.destination : "candidate";
    });
    if (!this.currentRequest.closed) {
      this.requestService.getSuitablesCandidate(this.idRequest, "candidate").then((result2: any) => {
        this.suitablesCandidates = result2.data;
        this.tabs_loaded_data.push("candidate");
        this.showSpinnerCandidate = false;
        this._changeDetectorRef.detectChanges();

        this.requestService.getSuitablesCandidate(this.idRequest, "employee").then((result: any) => {
          this.suitablesEmployees = result.data;
          this.tabs_loaded_data.push("employee");
          this.showSpinnerEmployee = false;
          this._changeDetectorRef.detectChanges();
        });

        this.requestService.getSuitablesCandidate(this.idRequest, "ex_employees").then((result3: any) => {
          this.suitablesExEmployees = result3.data;
          this.tabs_loaded_data.push("ex-employee");
          this.tabs_loaded_data.push("ex_employees");
          this.showSpinnerExEmployee = false;
          this._changeDetectorRef.detectChanges();
        });
      });
    } else {
      this.showSpinnerCandidate = false;
      this.showSpinnerEmployee = false;
      this.showSpinnerExEmployee = false;
      this.showTab = "proposed";
      this._changeDetectorRef.detectChanges();
    }

    await this.fillSteps();
    const requestTitle: string = this.currentRequest.request_name && this.currentRequest.request_name.length > 0 ? this.currentRequest.request_name : this.requestService.createRequestTitle(this.currentRequest);
    this.contentHeader = {
      headerTitle: requestTitle,
      actionButton: false,
      breadcrumb: {
        type: "",
        links: [
          {
            name: "Home",
            isLink: true,
            link: "/",
          },
          {
            name: "MENU.RECRUITMENT",
            isLink: false,
          },
          {
            name: "MENU.CUSTOMERS_REQUESTS",
            isLink: true,
            link: "/dashboard/requests-list",
          },
          {
            name: requestTitle,
            isLink: false,
          },
        ],
      },
    };

    this.basicDateOptions = {
      altFormat: "d/m/Y",
      defaultDate: "today",
      locale: Italian.it,
      altInput: true,
      utc: true,
      minDate: "today",
    };

    this.formGroup = this._formBuilder.group({
      note: new FormControl("", [Validators.required, Validators.minLength(5), Validators.maxLength(255)]),
      day: new FormControl("", [Validators.required, Validators.pattern("^\\d{4}\\-(0?[1-9]|1[012])\\-(0?[1-9]|[12][0-9]|3[01])$")]),
      time: new FormControl(
        {
          hour: Number(moment().format("HH")),
          minute: Number(moment().format("mm")),
        },
        [Validators.required, Validators.minLength(2), Validators.maxLength(2)],
      ),
    });
    this.setContainerHeight();
    this._utilService.hideLoading();
  }

  async fillSteps() {
    this.allStepList = await this.requestService.getSteps(Number(this.idRequest));
    this.allStepList = this.allStepList.sort((a, b) => (a.insert_date > b.insert_date ? -1 : 1));
    this.allTimeLineCandidates = this.allStepList;
    this.allStepList = this.allStepList.filter((value, index, self) => index === self.findIndex((t) => t.user_hash === value.user_hash && t.name === value.name));
    this.step0 = this.allStepList.filter((item) => item.step === 0);
    this.step1 = this.allStepList.filter((item) => item.step === 1);
    this.step2 = this.allStepList.filter((item) => item.step === 2);
    this.step3 = this.allStepList.filter((item) => item.step === 3);
    this.step4 = this.allStepList.filter((item) => item.step === 4);
    this.step5 = this.allStepList.filter((item) => item.step === 5);
    this.step6 = this.allStepList.filter((item) => item.step === 6);

    //Controllo se il candidato è presente in step0, se presente il bottone idoneo sarà disabilitato
    if (this.suitablesCandidates && this.suitablesCandidates.length > 0) {
      this.suitablesCandidates.map((item) => {
        item.suitables = this.step0.filter((step) => step.user_hash === item.hash);
        if (item.suitables && item.suitables.length > 0) {
          item.suitables = true;
        }
      });
    }
    //Controllo se il dipendente è presente in step0, se presente il bottone idoneo sarà disabilitato
    if (this.suitablesEmployees && this.suitablesEmployees.length > 0) {
      this.suitablesEmployees.map((item) => {
        item.suitables = this.step0.filter((step) => step.user_hash === item.hash);
        if (item.suitables && item.suitables.length > 0) {
          item.suitables = true;
        }
      });
    }
    //Controllo se l'ex dipendente è presente in step0, se presente il bottone idoneo sarà disabilitato
    if (this.suitablesExEmployees && this.suitablesExEmployees.length > 0) {
      this.suitablesExEmployees.map((item) => {
        item.suitables = this.step0.filter((step) => step.user_hash === item.hash);
        if (item.suitables && item.suitables.length > 0) {
          item.suitables = true;
        }
      });
    }
  }

  getTimeLineCandidates(user_hash: any) {
    this.singleTimeLineCandidate = this.allTimeLineCandidates.filter((item) => item.user_hash === user_hash);
    this.singleTimeLineCandidate.map(async (item: any) => {
      switch (item.step) {
        case 0:
          item.label_step = item.user.user_type === "candidate" ? await this._utilService.translate("TIMELINE_STEPS_LABELS.STEP_0_CANDIDATE") : await this._utilService.translate("TIMELINE_STEPS_LABELS.STEP_0_EMPLOYEE");
          item.color_step = "secondary";
          break;
        case 1:
          item.label_step = item.user.user_type === "candidate" ? await this._utilService.translate("TIMELINE_STEPS_LABELS.STEP_1_CANDIDATE") : await this._utilService.translate("TIMELINE_STEPS_LABELS.STEP_1_EMPLOYEE");
          item.color_step = "warning";
          break;
        case 2:
          item.label_step = await this._utilService.translate("TIMELINE_STEPS_LABELS.STEP_2");
          item.color_step = "info";
          break;
        case 3:
          item.label_step = await this._utilService.translate("TIMELINE_STEPS_LABELS.STEP_3");
          item.color_step = "info";
          break;
        case 4:
          item.label_step = item.user.user_type === "candidate" ? await this._utilService.translate("TIMELINE_STEPS_LABELS.STEP_4_CANDIDATE") : await this._utilService.translate("TIMELINE_STEPS_LABELS.STEP_4_EMPLOYEE");
          item.color_step = "danger";
          break;
        case 5:
          item.label_step = item.user.user_type === "candidate" ? await this._utilService.translate("TIMELINE_STEPS_LABELS.STEP_5_CANDIDATE") : await this._utilService.translate("TIMELINE_STEPS_LABELS.STEP_5_EMPLOYEE");
          item.color_step = "success";
          break;
        case 6:
          item.label_step = await this._utilService.translate("TIMELINE_STEPS_LABELS.STEP_6");
          item.color_step = "primary";
          break;
      }
    });
  }

  getItems() {
    let items: any = this.showTab === "candidate" ? this.suitablesCandidates : this.showTab === "employee" ? this.suitablesEmployees : this.suitablesExEmployees;
    const keyword: string = this.filter_string.toLowerCase();
    if (keyword.length > 1) {
      items = items.filter((item: any) => item.complete_name?.toLowerCase().includes(keyword) || item.working_city?.toLowerCase().includes(keyword));
    }
    return items;
  }

  filterPrimarySkillCandidate(list: any) {
    if (list.length === 1) {
      return list;
    }
    return list.filter((skill: any) => skill.primary === 1);
  }

  openModal(modal, user, from) {
    this.close_motivation = null;
    this.openParameter = false;
    this.formGroup.reset();
    if (from !== "close_request_btn") {
      this._modalService.open(modal, {
        centered: true,
        size: "lg",
      });
      this.selectedUser = user;
      this.fillRatingParameters(); /*Funzione che calcola il valore del rating a pallini nella modale del dettaglio del candidato*/
      this.selectedUser.skills = this.selectedUser.skills.filter((skill: any) => skill.skill !== null);
      if (this.selectedUser.language) {
        this.selectedUser.languages_complete = this.selectedUser.languages_complete.filter((item) => item.name !== null);
      }
      if (!!this.selectedUser.certifications) {
        this.selectedUser.certifications = this.selectedUser.certifications.filter((item) => item.name !== null);
      }
    } else {
      this._modalService.open(modal, {
        centered: true,
        size: "sm",
      });
    }
  }

  setContainerHeight() {
    let allContainerHeights = [this.step0?.length, this.step1?.length, this.step2?.length, this.step3?.length, this.step4?.length, this.step5?.length, this.step6?.length];
    return Math.max(...allContainerHeights) * 39 + "px";
  }

  async drop(event: CdkDragDrop<string[]>) {
    if (this.currentRequest.closed) {
      return false;
    }
    if (this.cannotDragCandidate(this.selectedSuitableCandidate)) {
      await this._utilService.showSWALInfo({ text: "ERROR_DRAG_CANDIDATE_ONLY_CREATOR" });
      return false;
    }

    this.dragEvent = event;
    this.landingStep = event.container.element.nativeElement.id; // valore in cui salvo in quale step arriva il candidato per settare la label della modal delle note Aggiungi nota stato
    //Controllo che l'utente non possa tornare indietro escluso lo step numero quattro(Ko)
    if (this.landingStep <= event.previousContainer.element.nativeElement.id && this.landingStep !== "step4") {
      return false;
    }
    //Controllo che l'utente non venga spostato direttamente allo step3(secondo colloquio)
    if (this.landingStep === "step3" && event.previousContainer.element.nativeElement.id !== "step2") {
      return false;
    }
    //Controllo ko l'utente è bloccato nello step4(ko)
    if (event.previousContainer.element.nativeElement.id === "step4") {
      return false;
    }
    //Controllo che l'utente possa andare in contrattazione soltanto da step ok
    if (this.landingStep === "step6" && event.previousContainer.element.nativeElement.id !== "step5") {
      return false;
    }

    if (event.container.element.nativeElement.id === "step2" || event.container.element.nativeElement.id === "step3") {
      const now = moment();
      const day = now.format("YYYY-MM-DD");
      this.formGroup.patchValue({ note: "", time: { hour: now.hours(), minute: now.minutes() }, day });
      this.basicDateOptions.defaultDate = day;
      this._modalService.open(this.noteDateModal, {
        centered: true,
        size: "sm",
        backdrop: false,
        keyboard: false,
      });
    } else {
      this._modalService.open(this.noteModal, {
        centered: true,
        size: "sm",
        backdrop: false,
        keyboard: false,
      });
    }
    if (event.previousContainer === event.container) {
      moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
    } else {
      transferArrayItem(event.previousContainer.data, event.container.data, event.previousIndex, event.currentIndex);
    }
  }

  fillRatingParameters() {
    /*Funzione che calcola il valore del rating a pallini nella modale del dettaglio del candidato*/
    this.selectedUser.parameters = {
      certifications: 0,
      city: 0,
      education_title: 0,
      figure: 0,
      site: 0,
      languages: 0,
      rate: 0,
      required_skills: 0,
      optional_skills: 0,
    };
    Object.keys(this.selectedUser.matrix_points).map((key) => {
      if (this.selectedUser.matrix_points[key] > 0 && this.usedParameters.includes(key)) {
        /*Se il punteggio dell'utente è maggiore di zero e il parametro viene richiesto riempiamo i palli di verde*/
        this.selectedUser.parameters[key] =
          (5 * this.selectedUser.matrix_points[key]) /
          this.parameterMax; /*i pallini sono cinque li moltiplichiamo per il valore del punteggio dell'utente e poi dividiamo per il valore massimo attribuibile a un parametro*/
      }
      if (this.selectedUser.matrix_points[key] === 0 && this.usedParameters.includes(key)) {
        /*Se il punteggio dell'utente è zero e il parametro viene richiesto riempiamo i palli di rosso*/
        this.selectedUser.parameters[key] = -1;
      }
    });
  }

  async selectBargainingOrCollaborator(hash: string) {
    await this._utilService
      .showSWAL({
        title: "ALERT_TITLE",
        text: "SELECT_EMPLOYEE_OR_COLLABORATOR",
        icon: "question",
        cancelButtonText: "COLLABORATOR",
        confirmButtonText: "EMPLOYEE",
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-info",
        },
      })
      .then(async (result) => {
        if (result.value) {
          await this.goToCreateBargaining(hash);
        } else if (result.isDismissed) {
          await this.goToTransformInCollaborator(hash);
        }
      });
  }

  async goToTransformInCollaborator(user_hash: string) {
    if (this._authenticationService.hasCapability("create_collaborator")) {
      await this.router.navigate(["/dashboard/collaborators/add"], { queryParams: { hash: user_hash, request: this.idRequest, request_name: this.currentRequest.request_name } });
    }
  }

  async goToCreateBargaining(user_hash: string) {
    if (this._authenticationService.hasCapability("create_bargaining")) {
      return this.bargainingService
        .checkIfUserHasBargaining(user_hash)
        .then(async (result: any) => {
          if (result.found) {
            await this._utilService.showSWALError({ text: "ERROR_CANDIDATE_IS_ALREADY_BARGAINING" });
          } else {
            await this.router.navigate(["/dashboard/create-bargaining/", user_hash, this.idRequest]);
          }
        })
        .catch(async (error: any) => {
          console.error(error);
          await this._utilService.showSWALError({ text: "ERROR_CANDIDATE_IS_ALREADY_BARGAINING" });
        });
    }
  }

  modalClose(action: string) {
    this._modalService.dismissAll();
    this.formGroup.patchValue({ note: "", time: { hour: null, minute: null }, day: null });
    this.basicDateOptions.defaultDate = moment().format("YYYY-MM-DD");
    this.callbackFn.emit();
    if (action === "back" && !this.editStepNumber) {
      transferArrayItem(this.dragEvent?.container?.data, this.dragEvent?.previousContainer?.data, this.dragEvent?.previousIndex, this.dragEvent?.currentIndex);
    }
    this.editStepNumber = null;
    this.dragEvent = null;
    this.selectedSuitableCandidate = null;
  }

  async setCandidateToSuitable(hash: string) {
    if (!this._authenticationService.hasCapability("edit_customer_request_step")) {
      window.history.back();
      this.modalClose("null");
      return false;
    }
    this._utilService.showLoading();
    const data = { step: 0, hash: hash, request_id: Number(this.idRequest) };
    await this.requestService
      .insertStep(data)
      .then(async () => {
        this._utilService.hideLoading();
        if (this.showTab === "candidate") {
          await this._utilService.showSWALSuccess({ text: "SUCCESS_INSERT_SUITABLE_CANDIDATE" });
          this.suitablesCandidates = this.suitablesCandidates.filter((item) => item.hash !== hash);
          await this.fillSteps();
        }
        if (this.showTab === "ex_employees") {
          await this._utilService.showSWALSuccess({ text: "SUCCESS_INSERT_SUITABLE_EX_EMPLOYEE" });
          this.suitablesExEmployees = this.suitablesExEmployees.filter((item) => item.hash !== hash);
          await this.fillSteps();
        }
        if (this.showTab === "employee") {
          await this._utilService.showSWALSuccess({ text: "SUCCESS_INSERT_SUITABLE_EMPLOYEE" });
          this.suitablesEmployees = this.suitablesEmployees.filter((item) => item.hash !== hash);
          await this.fillSteps();
        }
      })
      .catch(async () => {
        this._utilService.hideLoading();
        if (this.showTab === "candidate") {
          await this._utilService.showSWALError({ text: "ERROR_INSERT_SUITABLE_CANDIDATE" });
        }
        if (this.showTab === "ex_employees") {
          await this._utilService.showSWALError({ text: "ERROR_INSERT_SUITABLE_EX_EMPLOYEE" });
        }
        if (this.showTab === "employee") {
          await this._utilService.showSWALError({ text: "ERROR_INSERT_SUITABLE_EMPLOYEE" });
        }
      });
    this.modalClose("insertCandidate");
  }

  async insertStep() {
    if (!this._authenticationService.hasCapability("edit_customer_request_step")) {
      window.history.back();
      this.modalClose("null");
      return false;
    }
    const day: any = moment(Array.isArray(this.formGroup.value.day) ? this.formGroup.value.day[0] : this.formGroup.value.day);
    day.set("hour", this.formGroup.value.time.hour);
    day.set("minute", this.formGroup.value.time.minute);
    let data: any = {
      request_id: Number(this.idRequest),
      hash: this.selectedSuitableCandidate.user_hash,
      note: this.formGroup.value.note,
    };
    if (this.dragEvent?.container?.element?.nativeElement?.id === "step2" || this.dragEvent?.container?.element?.nativeElement?.id === "step3" || this.editStepNumber === "step2" || this.editStepNumber === "step3") {
      data.date = moment(day).format("YYYY-MM-DD HH:mm:00");
      //Controllo che la data non sia minore di quella odierna
      const today = moment().format("YYYY-MM-DD HH:mm:00");
      if (data.date < today) {
        await this._utilService.showSWALError({ text: "ERROR_DATE_REQUESTED" });
        return false;
      }
      //Controllo seconda data colloquio che non può essere minore alla data del primo colloquio
      if (this.dragEvent?.container?.element?.nativeElement?.id === "step3" || this.editStepNumber === "step3") {
        const firstInterviewDate = moment(this.selectedSuitableCandidate.date).utc().format("YYYY-MM-DD HH:mm:00");
        if (data.date < firstInterviewDate) {
          await this._utilService.showSWALError({ text: "CONTROL_SECOND_INTERVIEW_DATE" });
          return false;
        }
      }
    }
    //Inserisco il campo step tramite l'id del div della lista contenitore in cui viene dragato l'elemento
    data.step = this.editStepNumber ? Number(this.editStepNumber.replace("step", "")) : Number(this.dragEvent?.container?.element?.nativeElement?.id.replace("step", ""));
    this.modalClose("insertStep");

    //Svuoto la timeline del'utente cosi da nasconderla
    this.singleTimeLineCandidate = [];
    this._utilService.showLoading();
    await this.requestService
      .insertStep(data)
      .then(async () => {
        // await this.fillSteps();
        this.formGroup.patchValue({
          day: "",
          note: "",
          time: {
            hour: Number(moment().format("HH")),
            minute: Number(moment().format("mm")),
          },
        });
        this._utilService.hideLoading();
        await this._utilService.showSWALSuccess({ text: "SUCCESS_INSERT_STEP" });
      })
      .catch(async () => {
        this._utilService.hideLoading();
        await this._utilService.showSWALError({ text: "ERROR_INSERT_STEP" });
      });
  }

  async closeRequest() {
    if (!this._authenticationService.hasCapability("close_customer_request")) {
      window.history.back();
      return false;
    }
    const data = {
      motivation: this.close_motivation,
    };
    this._utilService.showLoading();
    await this.requestService
      .closeRequest(Number(this.idRequest), data)
      .then(async () => {
        this._utilService.hideLoading();
        this.modalClose("close_request_modal");
        await this._utilService.showSWALSuccess({ text: "SUCCESS_CLOSE_REQUEST" });
        await this.router.navigateByUrl("/dashboard/requests-list");
      })
      .catch(async () => {
        this._utilService.hideLoading();
        await this._utilService.showSWALError({ text: "ERROR_CLOSE_REQUEST" });
      });
  }

  async reOpenRequest() {
    if (!this._authenticationService.hasCapability("close_customer_request")) {
      window.history.back();
      return false;
    }
    this._utilService.showLoading();
    await this.requestService
      .reOpenRequest(Number(this.idRequest))
      .then(async () => {
        this._utilService.hideLoading();
        await this._utilService.showSWALSuccess({ text: "SUCCESS_OPEN_REQUEST" });
        await this.router.navigateByUrl("/dashboard/requests-list");
      })
      .catch(async () => {
        this._utilService.hideLoading();
        await this._utilService.showSWALError({ text: "ERROR_OPEN_REQUEST" });
      });
  }

  async deleteRequest() {
    if (!this._authenticationService.hasCapability("delete_customer_request")) {
      window.history.back();
      return false;
    }

    let deleteText: string = await this._utilService.translate("ALERT.CONFIRM_DELETE_TEXT");
    deleteText += await this._utilService.translate("ALERT.CONFIRM_DELETE_THIS_OBJECT");
    deleteText += this.requestService.createRequestTitle(this.currentRequest);

    await this._utilService
      .showSWALDeleteConfirmation({ text: deleteText })
      .then(async (result) => {
        if (result.value) {
          await this.requestService.deleteRequest(Number(this.idRequest));
          await this.router.navigateByUrl("/dashboard/requests-list");
          await this._utilService.showPopupItemDeleted().then(async () => {});
        } else if (result.isDismissed) {
          await this._utilService.showSWALError({
            title: "ABORTED_TITLE",
            text: "ABORTED_TEXT",
          });
        }
      })
      .catch(() => this._utilService.showSWALError({ text: "ERROR_DELETE_REQUEST" }));
  }

  changeTab(tab: string) {
    this.activeTab = this.activeTab === tab ? "" : tab;
    this._changeDetectorRef.detectChanges();
  }

  navigateToProfile(user: any) {
    const url = this.router.serializeUrl(this.router.createUrlTree([user.user.user_type === "candidate" ? "/dashboard/candidate/edit/" + user.user_hash : "/dashboard/user/profile/" + user.user_hash]));
    window.open(url, "_blank");
  }

  openEditCall(item) {
    this.selectedSuitableCandidate = item;
    this.formGroup.patchValue({
      day: moment(this.selectedSuitableCandidate.date),
      time: {
        hour: Number(moment(this.selectedSuitableCandidate.date).format("HH")),
        minute: Number(moment(this.selectedSuitableCandidate.date).format("mm")),
      },
      note: item.note,
    });
    this.basicDateOptions.defaultDate = item.date;

    if (item && item.step === 2) {
      this.editStepNumber = "step2";
    } else if (item && item.step === 3) {
      this.editStepNumber = "step3";
    }
    this._modalService.open(this.noteDateModal, {
      centered: true,
      size: "sm",
      backdrop: false,
      keyboard: false,
    });
  }

  cannotDragCandidate(item: any) {
    return item.creator.hash !== this.me.hash && !this._authenticationService.hasCapability("edit_customer_request_step_for_other_users");
  }
}
